enum CallOutcome {
    Connected = 1,
    NoAnswer = 2,
    Engaged = 3,
    Voicemail = 4
}

export default CallOutcome;

export const CallOutcomeLabels: { [key: number]: string } = {
    [CallOutcome.Connected]: 'Connected',
    [CallOutcome.NoAnswer]: 'No Answer',
    [CallOutcome.Engaged]: 'Engaged',
    [CallOutcome.Voicemail]: 'Voicemail'
};
